const ConsentBanner = null;

export default ConsentBanner;
